export type JobStatus = 'pending' | 'in-progress' | 'completed' | 'urgent';

export interface JobStatusDisplay {
  /** Human-readable label shown on badges. */
  label: string;
  /** Tailwind classes for the badge background/text (light + dark). */
  color: string;
}

/**
 * Display config for a job's lifecycle status — badge label and colour.
 *
 * Shared by the calendar job cards and the job details modal so the same
 * status renders identically everywhere. Note this is the `{ label, color }`
 * badge variant; `JobCard` deliberately uses a separate icon-led palette.
 */
export const JOB_STATUS_CONFIG: Record<JobStatus, JobStatusDisplay> = {
  pending: {
    label: 'Not Started',
    color: 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-100',
  },
  'in-progress': {
    label: 'In Progress',
    color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-200',
  },
  completed: {
    label: 'Completed',
    color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-200',
  },
  urgent: {
    label: 'Urgent',
    color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-200',
  },
};
